import { useQuery } from "@tanstack/react-query"

import { API_AUTH_URL } from "../constants"
import { IAuthRequest, IAuthResponse } from "../interface"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"
import { getFingerPrint as getFingerprint } from "../../utils/fingerprint"

export async function authRequest(
  token: string | null,
  request: IAuthRequest
) {
  const response = await axios({
    method: "POST",
    url: `${API_AUTH_URL}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: request,
  })

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useAuthRequest = (exchangeToken: string | null, enabled: boolean = true) => {
  const fingerprint = getFingerprint(true)

  return useQuery<IAuthResponse>({
    queryKey: ["fingerprint-auth"],
    queryFn: async () => {
      const result = await authRequest(exchangeToken, {
        fingerprint: fingerprint!,
        url: ""
      })
      return result
    },
    enabled: enabled && Boolean(exchangeToken) && Boolean(fingerprint),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
